import datevRoutes from '@src/accounting/routes/datev-routes';
import printInvoiceRoutes from '@src/accounting/routes/print-invoice-routes';
import accountingDocumentRoutes from '@src/accounting-document/routes';

export default [
    ...accountingDocumentRoutes,
    ...datevRoutes,
    {
        path: '/accounting/customer-account/customer-account-statement-datev/:datevId?',
        name: 'accounting_customer_account_statement_datev',
        component: () => import('@src/accounting/customer-account/customer-account-statement-by-datev-number'),
        props(route) {
            return { datevId: route.params.datevId ? route.params.datevId : null };
        },
        meta: {
            title: 'Kundenkontoauszug nach DATEV Nummer',
            role: 'ROLE_CUSTOMER_ACCOUNT_STATEMENT',
        },
    },
    ...printInvoiceRoutes,
];
